import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "./Reveal";

export default function Lookbook() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [-50, 50]);
  const y2 = useTransform(scrollYProgress, [0, 1], [70, -70]);
  const y3 = useTransform(scrollYProgress, [0, 1], [-30, 80]);

  return (
    <section
      id="lookbook"
      ref={ref}
      data-testid="lookbook-section"
      className="grain relative overflow-hidden bg-ink px-6 py-28 md:px-12 md:py-40"
    >
      <div className="aura-strong absolute left-1/2 top-1/2 aspect-square w-[min(90vw,700px)] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-60" />

      <div className="relative z-10 mx-auto max-w-6xl">
        <FadeUp>
          <p className="font-mono text-[10px] tracking-[0.45em] text-cream/50">03 — LOOKBOOK</p>
        </FadeUp>
        <FadeUp delay={0.08}>
          <h2 className="mt-4 font-script text-6xl leading-none text-starlight md:text-8xl">
            worn by the sun
          </h2>
        </FadeUp>

        <div className="mt-16 grid grid-cols-3 gap-4 md:gap-8">
          <motion.div style={{ y: y1 }} className="border border-cream/15 bg-cream/5 p-2">
            <img src="/assets/shop-clothing.png" alt="MarStar aura tee" loading="lazy" className="w-full object-cover" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="mt-10 border border-cream/15 bg-cream/5 p-2 md:mt-20">
            <img src="/assets/shop-jewelry.png" alt="MarStar sun, star and moon jewelry" loading="lazy" className="w-full object-cover" />
          </motion.div>
          <motion.div style={{ y: y3 }} className="border border-cream/15 bg-cream/5 p-2">
            <img src="/assets/shop-customs.png" alt="MarStar custom star denim" loading="lazy" className="w-full object-cover" />
          </motion.div>
        </div>

        <FadeUp delay={0.1}>
          <p className="mt-14 text-center font-mono text-[11px] tracking-[0.5em] text-cream/60">
            NO TWO STARS LAND THE SAME
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
